<section class="playground">
  <h2 class="playground__heading">Badge</h2>
  <p class="playground__hint">
    <code>app-badge</code> para contadores numéricos y puntos de estado.
  </p>

  <div class="playground__grid">
    <div class="playground__controls">
      <label class="playground__field">
        <span>value</span>
        <input type="number" [(ngModel)]="value" />
      </label>

      <label class="playground__field">
        <span>size</span>
        <select [(ngModel)]="size">
          <option *ngFor="let s of sizes" [value]="s">{{ s }}</option>
        </select>
      </label>

      <label class="playground__field">
        <span>color</span>
        <select [(ngModel)]="color">
          <option *ngFor="let c of colors" [value]="c">{{ c }}</option>
        </select>
      </label>

      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="asString" />
        <span>usar valor string</span>
      </label>
    </div>

    <div class="playground__preview">
      <p class="playground__preview-title">Preview</p>
      <div class="playground__preview-box">
        <app-badge
          [value]="asString ? (value + '') : value"
          [size]="size"
          [color]="color"
        ></app-badge>
      </div>
    </div>
  </div>

  <div class="playground__section">
    <p class="playground__preview-title">Colores de status</p>
    <div class="playground__row">
      <div *ngFor="let c of colors" class="playground__color-sample">
        <app-badge [value]="7" size="medium" [color]="c"></app-badge>
        <span class="playground__label">{{ c }}</span>
      </div>
    </div>
  </div>

  <div class="playground__section">
    <p class="playground__preview-title">Tamaños</p>
    <div class="playground__row playground__row--align-center">
      <div class="playground__color-sample">
        <app-badge [value]="7" size="medium" color="red"></app-badge>
        <span class="playground__label">medium</span>
      </div>
      <div class="playground__color-sample">
        <app-badge [value]="99" size="large" color="red"></app-badge>
        <span class="playground__label">large</span>
      </div>
      <div class="playground__color-sample">
        <app-badge [value]="0" size="small" color="red"></app-badge>
        <span class="playground__label">small (dot)</span>
      </div>
    </div>
  </div>
</section>
